// extracted by mini-css-extract-plugin
module.exports = {"title":"styles_title__Tnvl8","bet":"styles_bet__O_VoD","description":"styles_description__5k6z1","buttonWrapper":"styles_buttonWrapper__a8Uim","image":"styles_image__iXcuX"};